// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2awDG","toggle":"styles_toggle__15q2J","preview":"styles_preview__xdhzr"};